// inputFieldUtils.ts
import { v4 as uuid } from 'uuid';

import {
  InputFieldTypeLegacy,
  FilterLegacy,
  SimpleEventFilterType,
  DerivedEventFilterType,
} from '@verantos-dev/types-cohorts';

import { ValueType } from '../rules';

export const VALUE_TYPE_TO_INPUT_TYPE: Record<ValueType, InputFieldTypeLegacy> = {
  [ValueType.DAYS]: InputFieldTypeLegacy.INT_NUMERIC_FIELD,
  [ValueType.FLOAT]: InputFieldTypeLegacy.FLOAT_NUMERIC_FIELD,
  [ValueType.CONCEPT]: InputFieldTypeLegacy.CONCEPT_COMBO_BOX,
  [ValueType.INTEGER]: InputFieldTypeLegacy.INT_NUMERIC_FIELD,
};

export const VALUE_TYPE_TO_INPUT_LABEL: Record<ValueType, string> = {
  [ValueType.DAYS]: 'Days',
  [ValueType.FLOAT]: 'Number',
  [ValueType.CONCEPT]: 'Concept group',
  [ValueType.INTEGER]: 'Number',
};

const INPUT_FIELDS = {
  [SimpleEventFilterType.CONCEPT]: 3,
  [SimpleEventFilterType.NUMERIC]: 3,
  [SimpleEventFilterType.RELATED_ENTITY]: 4,
  [SimpleEventFilterType.UNIQUENESS]: 4,
};

const DERIVED_EVENT_INPUT_FIELDS = {
  [DerivedEventFilterType.UNIQUENESS]: 4,
  [DerivedEventFilterType.TEMPORAL]: 3,
  [DerivedEventFilterType.EVENT]: 3,
};

export const mutateInputFields = (filter: FilterLegacy, filterType: SimpleEventFilterType) => {
  filter.inputFields = [
    ...filter.inputFields.map(({ id, value }) => ({ id, value })),
    ...Array.from({ length: INPUT_FIELDS[filterType] - filter.inputFields.length }, () => ({
      id: uuid(),
      value: '',
    })),
  ];
};

export const mutateInputFieldsDerivedEvents = (
  filter: FilterLegacy,
  filterType: DerivedEventFilterType
) => {
  filter.inputFields = [
    ...filter.inputFields.map(({ id, value }) => ({ id, value })),
    ...Array.from(
      { length: DERIVED_EVENT_INPUT_FIELDS[filterType] - filter.inputFields.length },
      () => ({
        id: uuid(),
        value: '',
      })
    ),
  ];
};
